// src/components/LoginRequiredModal.jsx
import React from 'react';
import '../styles/LoginRequiredModal.css';

const LoginRequiredModal = ({ isOpen, onClose, onLogin, message }) => {
  if (!isOpen) return null;

  return (
    <div className="login-required-overlay" onClick={onClose}>
      <div className="login-required-modal" onClick={(e) => e.stopPropagation()}>
        <button className="lr-close-button" onClick={onClose}>×</button>

        <div className="lr-icon">🔒</div>
        <h2 className="lr-title">Login Required</h2>
        <p className="lr-message">
          {message || 'Please login to continue with this action.'}
        </p>

        <div className="lr-actions">
          <button className="lr-login-btn" onClick={onLogin}>
            Login Now
          </button>
          <button className="lr-cancel-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal;